import _ from "lodash";
import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import { default as markerEco } from '../../../../images/marker_eco.svg';
import { default as markerTree } from '../../../../images/Marker_tree.svg';
import { default as markerTree100 } from '../../../../images/tree_100.svg';
import {GoogleMapsStyle, mapData} from './GoogleMapUtil';


const EcoAllianceMap = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAy9fHaYfUW7xCO-VTL5JWsVuAF6wiwAvg&libraries=places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `580px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap,
)(props => 
  (
  <GoogleMap
    defaultOptions={{
      styles: GoogleMapsStyle,
      backgroundColor: 'hsla(0, 0%, 0%, 0)',
      fullscreenControl: false,
      streetViewControl: false,
      draggable: props.isMobile ? true : false,
      disableDefaultUI: true, 
      zoomControlOptions: { position: 9 },
      keyboardShortcuts: true, 
      scaleControl: true, 
      scrollwheel: props.isMobile ? true : false,
      minZoom : props.isMobile ? 1 : 2,
      maxZoom : 4,
    }}
    defaultZoom={2}
    defaultCenter={props.isMobile ? { lat: -36.848, lng: 174.763 } : { lat: 20.000, lng: 10.000 }}
  >
    {
      mapData.map((marker, idx) => {
        return <Marker
          key={`marker-${idx}`}
          width={30}
          position={marker.coords}
          onClick={() => props.onClicked(marker)}
          icon={
            { 
              url : marker.icon === 'eco' ? markerEco : marker.icon === 'markerTree100' ? markerTree100 : markerTree , 
              scaledSize : new window.google.maps.Size(80, 80)  
            }
          }
        />
      })
    }
  </GoogleMap>
));

const enhance = _.identity;

const ReactGoogleMaps = (props) => [
  <EcoAllianceMap {...props} key="map" />
];

export default enhance(ReactGoogleMaps);